/**
 * @generated SignedSource<<4191c83d97bcf3c010f4c44e5f1df57e>>
 * @relayHash c27dc099805c7eec7a9354a821bd73cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 717eb51b235f5f25635e4ecef7a7a139da3e0a671a31ec57022615806587618b

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceStarShortcutListenerIsSpaceFavouritedQuery$variables = {
  spaceKey: string;
};
export type SpaceStarShortcutListenerIsSpaceFavouritedQuery$data = {
  readonly space: {
    readonly alias: string | null;
    readonly currentUser: {
      readonly isFavourited: boolean;
    };
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
};
export type SpaceStarShortcutListenerIsSpaceFavouritedQuery = {
  response: SpaceStarShortcutListenerIsSpaceFavouritedQuery$data;
  variables: SpaceStarShortcutListenerIsSpaceFavouritedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isFavourited"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c27dc099805c7eec7a9354a821bd73cc",
    "id": "717eb51b235f5f25635e4ecef7a7a139da3e0a671a31ec57022615806587618b",
    "metadata": {},
    "name": "SpaceStarShortcutListenerIsSpaceFavouritedQuery",
    "operationKind": "query",
    "text": "query SpaceStarShortcutListenerIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
  }
};
})();

(node as any).hash = "ee6489b807b5c87efd54daae89947f35";

export default node;
